import { useSelect, useDispatch }  from '@wordpress/data';
import { __ }                       from '@wordpress/i18n';
import { STORE_NAME, ORDER_OPTIONS } from '../../../store';

export default function SortFilter( { showLabel = true } ) {
	const orderby         = useSelect( ( s ) => s( STORE_NAME ).getOrderby(), [] );
	const { setOrderby }  = useDispatch( STORE_NAME );

	return (
		<div className="mwsb-filter mwsb-filter--sort">
			{ showLabel && <label className="mwsb-filter__label" htmlFor="mwsb-sort-select">{ __( 'Sort by', 'mwsb' ) }</label> }
			<div className="mwsb-select-wrap">
				<select
					id="mwsb-sort-select"
					className="mwsb-select"
					value={ orderby }
					onChange={ ( e ) => setOrderby( e.target.value ) }
				>
					{ ORDER_OPTIONS.map( ( o ) => (
						<option key={ o.value } value={ o.value }>{ o.label }</option>
					) ) }
				</select>
				<svg className="mwsb-select-chevron" viewBox="0 0 24 24" width="14" height="14">
					<path d="M6 9l6 6 6-6" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round"/>
				</svg>
			</div>
		</div>
	);
}
